/* global axios */
import ApiClient from './ApiClient';

class WebHooks extends ApiClient {
  constructor() {
    super('webhooks', { accountScoped: true });
  }

  // Manda um evento de teste agora; a resposta traz { delivery: { ok, http_status, error, at } }.
  test(id) {
    return axios.post(`${this.url}/${id}/test`);
  }
}

export default new WebHooks();
